import { variableFunctions as globalVariableFunctions } from './global';
import { variableFunctions as hospitalIndemnityVariableFunctions } from './hospitalIndemnity';
import { variableFunctions as petInsuranceVariableFunctions } from './petInsurance';
import { variableFunctions as cancerInsuranceVariableFunctions } from './cancerInsurance';
// Mustache templated variables in dt.vtt files and Kentico text/rich text fields
// must have a corresponding Convenience Variable returned by this function
// in order to render properly on screen
export function getConvenienceVariables(contentData) {
    return {
        ...evaluateVariables(globalVariableFunctions, '', contentData),
        ...evaluateVariables(hospitalIndemnityVariableFunctions, 'HI_', contentData),
        ...evaluateVariables(petInsuranceVariableFunctions, 'pet_', contentData),
        ...evaluateVariables(cancerInsuranceVariableFunctions, 'cancer_', contentData),
    };
}
function evaluateVariables(variables, prefix, data) {
    const values = Object.entries(variables).map(([k, func]) => [
        `${prefix}${k}`,
        func(data),
    ]);
    return Object.fromEntries(values);
}
//# sourceMappingURL=index.js.map